import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

export default function LoginPage() {
  const { user, login } = useAuth()
  const navigate = useNavigate()
  const [isLoggingIn, setIsLoggingIn] = useState(false)

  useEffect(() => {
    if (user) {
      navigate('/')
    }
  }, [user, navigate])

  const handleLogin = () => {
    if (isLoggingIn) return
    setIsLoggingIn(true)
    login()
  }

  return (
    <div className="max-w-md mx-auto text-center">
      <h1 className="text-3xl font-bold mb-6">Login</h1>
      <button
        onClick={handleLogin}
        disabled={isLoggingIn}
        className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-500 disabled:bg-gray-400 disabled:cursor-not-allowed"
      >
        {isLoggingIn ? 'Redirecting...' : 'Sign in with Google'}
      </button>
    </div>
  )
}
